"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "Didomi", {
    enumerable: true,
    get: function() {
        return Didomi;
    }
});
var _logger = require("../../helpers/logger");
var _sdk = require("./sdk");
var _runCallback = require("../../helpers/runCallback");
var _utils = require("./utils");
var _config = require("./config");
var Didomi = function() {
    var options = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    var debug = options.debug, id = options.id;
    var logger = (0, _logger.getLogger)(debug);
    var cookieSaveCallback = null;
    var checkDidomi = function(callback) {
        if (typeof callback !== "function" || typeof window === "undefined") {
            return;
        }
        if (window.isDidomiReady) {
            callback();
        }
        var check = function() {
            if (window.isDidomiReady) {
                clearInterval(intervalID);
                callback();
            }
        };
        var intervalID = setInterval(check, 500);
    };
    /**
   * This method is used to re-open the Cookie Banner
   *
   * @return void
   */ var onOpenCookieBanner = function() {
        setTimeout(function() {
            // Update preferences User
            var cookieBannerLinksArray = document.querySelectorAll("a[href='#open-cookie-banner']");
            if (cookieBannerLinksArray.length !== 0) {
                Array.from(cookieBannerLinksArray).forEach(function(cookieBannerLink) {
                    cookieBannerLink.addEventListener("click", function(event) {
                        var _window_Didomi;
                        event.preventDefault();
                        (_window_Didomi = window.Didomi) === null || _window_Didomi === void 0 ? void 0 : _window_Didomi.preferences.show();
                    });
                });
            }
        }, 1000);
    };
    /**
   * This method is used to open Cookies Report on /about/cookies static page
   *
   * @return void
   */ var onClickCookiesReport = function() {
        var cookiesReportLinksArray = document.querySelectorAll("a[href='#cookies-report']");
        if (cookiesReportLinksArray.length === 0) {
            return;
        }
        Array.from(cookiesReportLinksArray).forEach(function(link) {
            link.addEventListener("click", function(event) {
                var _window_Didomi;
                event.preventDefault();
                (_window_Didomi = window.Didomi) === null || _window_Didomi === void 0 ? void 0 : _window_Didomi.preferences.show("vendors");
            });
        });
    };
    var loadDidomi = function() {
        var userId = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "", callback = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : null;
        var onLoad = function onLoad() {
            (0, _utils.sendUserConsentsToGTM)(userId);
            logger.info("🍪 Didomi - SDK is loaded");
            onOpenCookieBanner();
            onClickCookiesReport();
            window.isDidomiReady = 1;
            (0, _runCallback.runCallback)(callback);
        };
        var onConsentChange = function onConsentChange() {
            (0, _runCallback.runCallback)(cookieSaveCallback);
            (0, _utils.sendUserConsentsToGTM)(userId);
        };
        if (!id || typeof id !== "string") {
            logger.debug("🍪 Didomi - 'options.id' does not meet the expected requirements: should be a valid string credential.");
            return;
        }
        // Didomi loading is already ongoing (either pending - 0 - or done - 1 -)
        if (typeof window.isDidomiReady !== "undefined") {
            return;
        }
        window.isDidomiReady = 0;
        var didomiScript = document.getElementById("spcloader");
        var isDidomiLoadedByServer = didomiScript && didomiScript.dataset.server === "true";
        if (didomiScript) {
            // Only the main script is loaded and it won't be loaded another time as it is now prevented in the sdk file.
            // But the sdk needs more initialization.
            logger.debug("🍪 Didomi - SDK is already loaded");
            // Safety mechanism to prevent the load logic to happen twice ?
            if (!isDidomiLoadedByServer) {
                return;
            }
        }
        // https://developers.didomi.io/cmp/web-sdk/reference/events
        window.didomiEventListeners = window.didomiEventListeners || [];
        window.didomiEventListeners.push({
            event: "consent.changed",
            listener: function listener() {
                onConsentChange();
            }
        });
        if (!window.didomiConfig) {
            window.didomiConfig = (0, _config.getDidomiConfig)(options);
        }
        // window.Didomi is used to check if the SDK is loaded since it's exposed by the SDK
        if (window.Didomi) {
            onLoad();
            if (window.hasDidomiConsentChanged) {
                onConsentChange();
            }
        } else {
            window.didomiOnReady = window.didomiOnReady || [];
            window.didomiOnReady.push(onLoad);
            (0, _sdk.didomiSDK)(id);
        }
    };
    onOpenCookieBanner();
    return {
        getUserConsents: _utils.getUserConsents,
        checkDidomi: checkDidomi,
        load: function(userId, callback) {
            loadDidomi(userId, callback || null);
        },
        onConsentChange: function(callback) {
            if (typeof callback === "function") {
                cookieSaveCallback = callback;
            }
        }
    };
};

//# sourceMappingURL=index.js.map